import React, { useState } from 'react';
import { Package } from 'lucide-react';
import { cn } from '@/lib/utils';
import Icon from './Icon';

interface ProductThumbProps {
  src?: string | null;
  alt: string;
  /** md: 56px (cards) · sm: 44px (summaries). */
  size?: 'md' | 'sm';
  className?: string;
}

/** Rounded product photo; falls back to a package icon when there's no image or it fails to load. */
const ProductThumb: React.FC<ProductThumbProps> = ({ src, alt, size = 'md', className }) => {
  const [failed, setFailed] = useState(false);
  return (
    <span
      className={cn(
        'tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-xl tw-bg-ds-subtle',
        size === 'md' ? 'tw-h-14 tw-w-14' : 'tw-h-11 tw-w-11',
        className,
      )}
    >
      {src && !failed ? (
        <img src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} className="tw-h-full tw-w-full tw-object-cover" />
      ) : (
        <Icon icon={Package} size={24} className="tw-text-ds-text-tertiary" />
      )}
    </span>
  );
};

export default ProductThumb;
